function createRules(app) {
  return {
    //オーナーID  チェック  ・桁数チェック  ・必須チェック  ・型チェック
    ownerExId: [
      {
        required: true,
        trigger: 'change',
        message: app.$t('message.common.validation.required', {
          field: app.$t('label.system.owner.create.ownerExId')
        })
      },
      {
        max: 20,
        trigger: 'change',
        message: app.$t('message.common.validation.size', {
          field: app.$t('label.system.owner.create.ownerExId'),
          length: 20
        })
      },
      {
        pattern:  /^[A-Za-z0-9]+$/,
        trigger: 'change',
        message: app.$t('message.common.validation.type', {
          field: app.$t('label.system.owner.create.ownerExId'),
          type: '半角英数字'
        })
      }
    ],
    //オーナー名  チェック  ・桁数チェック  ・必須チェック  ・型チェック
    ownerName: [
      {
        required: true,
        trigger: 'change',
        message: app.$t('message.common.validation.required', {
          field: app.$t('label.system.owner.create.ownerName')
        })
      },
      {
        max: 50,
        trigger: 'change',
        message: app.$t('message.common.validation.size', {
          field: app.$t('label.system.owner.create.ownerName'),
          length: 50
        })
      }
    ],
    //ポイント変換率  ・型チェック  ・必須チェック
    pointFeeRate: [
      {
        required: true,
        trigger: 'change',
        message: app.$t('message.common.validation.required', {
          field: app.$t('label.system.owner.create.pointFeeRate')
        })
      },
      {
        pattern: /^([0-9]\d{0,4}?(\.\d{1,2})?|0\.\d{1,2}|100)$/,
        trigger: 'change',
        message: "ポイント手数料率は整数3桁、小数1桁文字以下でご入力ください。"
      },
      {
        pattern:  /^100$|^([0-9]{0,2})(\.\d{0,3})?$/,
        trigger: 'change',
        message: app.$t('message.common.pointMax', {
          field: app.$t('label.system.owner.create.pointFeeRate')
        })
      },
    ],
    //ポイント変換率  ・型チェック  ・必須チェック
    pointExcRate: [
      {
        required: true,
        trigger: 'change',
        message: app.$t('message.common.validation.required', {
          field: app.$t('label.system.owner.create.pointExcRate')
        })
      },
      {
        pattern: /^([0-9]\d{0,4}?(\.\d{1,2})?|0\.\d{1,2}|100)$/,
        trigger: 'change',
        message: "ポイント変換率は整数3桁、小数1桁文字以下でご入力ください。"
      },
      {
        pattern:  /^100$|^([0-9]{0,2})(\.\d{0,3})?$/,
        trigger: 'change',
        message: app.$t('message.common.pointMax', {
          field: app.$t('label.system.owner.create.pointExcRate')
        })
      },
    ],
    //サービス開通日時  ・必須チェック
    serviceStartDt: [
      {
        required: true,
        trigger: 'change',
        message: app.$t('message.common.validation.required', {
          field: app.$t('label.system.owner.create.serviceStartDt')
        })
      }
    ],
    //責任者情報.氏名  チェック  ・桁数チェック  ・型チェック
    resUserName: [
      {
        max: 50,
        trigger: 'change',
        message: app.$t('message.common.validation.size', {
          field: app.$t('label.system.owner.create.respUserName'),
          length: 50
        })
      }
    ],

    //責任者情報.電話番号  チェック  ・桁数チェック  ・型チェック
    respUserTel: [
      {
        pattern: /^[0-9/-]*$/,
        trigger: 'change',
        message: app.$t('message.common.validation.telNoMessage')
      },
      // {
      //   min: 10,
      //   trigger: 'change',
      //   message: app.$t('message.common.validation.min', {
      //     field: app.$t('label.system.owner.create.companyTel'),
      //     length: 10
      //   })
      // },
      {
        max: 20,
        trigger: 'change',
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.system.owner.create.companyTel'),
          length: 20
        })
      }
    ],

    //責任者情報.メールアドレス  チェック  ・桁数チェック  ・型チェック
    respUserEmail: [
      {
        pattern: /^[!#$%'*+\-0-9=?A-Z^_`a-z{}~]+(\.[!#$%'*+\-0-9=?A-Z^_`a-z{}~]+)*@(?![\d]+(\.[\d]+)*$)[!#$%'*0-9=?A-Z^`a-z{}~]+([!#$%'*\-0-9=?A-Z^_`a-z{}~]*[!#$%'*0-9=?A-Z^`a-z{}~]+)*(\.[!#$%'*0-9=?A-Z^`a-z{}~]+([!#$%'*\-0-9=?A-Z^_`a-z{}~]*[!#$%'*0-9=?A-Z^`a-z{}~]+)*)+$/,
        trigger: 'change',
        message: app.$t('message.common.validation.emailType')
      }
    ],

    //責任者情報.契約番号  チェック  ・桁数チェック  ・型チェック
    respUserContractNo: [
      {
        max: 20,
        trigger: 'change',
        message: app.$t('message.common.validation.size', {
          field: app.$t('label.system.owner.create.respUserContractNo'),
          length: 20
        })
      },
      {
        pattern: /^[A-Za-z0-9]+$/,
        trigger: 'change',
        message: app.$t('message.common.validation.type', {
          field: app.$t('label.system.owner.create.respUserContractNo'),
          type: '半角英数字'
        })
      }
    ],

    //本社情報.住所  チェック  ・桁数チェック  ・型チェック
    companyAddress: [
    ],

    //本社情報.電話番号  チェック  ・桁数チェック  ・型チェック
    companyTel: [
      {
        pattern: /^[0-9/-]*$/,
        trigger: 'change',
        message: app.$t('message.common.validation.telNoMessage')
      },
      // {
      //   min: 10,
      //   trigger: 'change',
      //   message: app.$t('message.common.validation.min', {
      //     field: app.$t('label.system.owner.create.companyTel'),
      //     length: 10
      //   })
      // },
      {
        max: 20,
        trigger: 'change',
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.system.owner.create.companyTel'),
          length: 20
        })
      }
    ]
  }
}
export default {
  createRules: createRules
}
